<template lang="pug">
.stars(role="img" :aria-label="label")
  svg.row(aria-hidden="true" focusable="false" :viewBox="VIEW_BOX")
    path(v-for="offset in OFFSETS" :key="offset" :d="STAR" :transform="`translate(${offset} 0)`")
  .color(:style="{ width: (($props.rating/5.00) * 100.00) + '%' }" :class="[color]" aria-hidden="true")
    svg.row(focusable="false" :viewBox="VIEW_BOX")
      path(v-for="offset in OFFSETS" :key="offset" :d="STAR" :transform="`translate(${offset} 0)`")
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRogue } from '../../js/rogue'

const props = withDefaults(defineProps<{
  rating?: number,
  color?: 'yellow' | 'black',
}>(), {
  rating : 0,
  color  : 'yellow',
})

// Five 24x24 stars in a row
const STAR = 'M12 1.5l3.09 6.97 7.41.68-5.6 4.98 1.65 7.37L12 17.67 5.45 21.5l1.65-7.37-5.6-4.98 7.41-.68z'
const OFFSETS = [0, 24, 48, 72, 96]
const VIEW_BOX = '0 0 120 24'

const rogue = useRogue()

const label = computed(() => {
  const rating = Math.round((Number(props.rating) || 0) * 10) / 10

  return rating > 0
    ? rogue.__('Rated {rating} out of 5 stars', { rating: String(rating) })
    : rogue.__('Not yet rated')
})
</script>
<style lang="scss" scoped>

.stars {
  user-select: none;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  color: $color-gray-light;
}

.row {
  display: block;
  width: 5em;
  height: 1em;
  fill: currentColor;
}

.color {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  &.yellow {
    color: $color-yellow;
  }

  &.black {
    color: $color-black;
  }
}
</style>
